import React, { Component } from 'react';
import { Link, Router, Route, browserHistory } from 'react-router';

import Header from './components/header';
import logo from './logo.svg';
import './App.css';


class Home extends Component {
  render() {
    return (
      <div className="home">
        <div className="container">
          <div className="col-xl-12">
            <h1>Welcome</h1>
            <p>For over 40 years, Fisher & Ho CPA's (previously named Fisher and Bagley CPA's) mission has been to assist our clients through their tax woes. Our firm strives to assist our clients with the least amount of stress and highest tax savings at affordable and competitive rates.</p>

            <p> We offer a wide variety of tax services for individuals, estates, and businesses.</p>

            <p>Contact us today to see how we can ease your tax situation.</p>
                <span>Our areas of expertise include:</span>
                <ul>
                  <li>Tax Return Preparation</li>
                  <li>Tax Return Amendments</li>
                  <li>Tax Planning and Advice</li>
    	            <li>Audit Representation</li>
                  <li>Small Business Accounting</li>
                  <li>Bookkeeping</li>
                  <li>Payroll Processing</li>
                </ul>
                <p>We are experienced, collaborative, and trustworthy. We speak English, Mandarin, and Cantonese 國語和粤語. Feel free to call us for a free initial 10 minute consultation.</p>
                <br /><br />
                <h2>News</h2>
                <ul>
                  <li><a href={require('./assets/newsletters/2018-Tax-Changes.pdf')}>2018 Tax Changes - The Tax Cuts and Jobs Act</a></li>
                </ul>

          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js